import type { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import type CrmFundraisingDonation from '@/types/serializers/CrmFundraisingDonation'
import {
  DONATION_STATUS_LABELS,
  STATUS_BADGE_VARIANT,
} from '@/lib/fundraising-labels'

export const donationColumns: ColumnDef<CrmFundraisingDonation, unknown>[] = [
  {
    accessorKey: 'donor_name',
    header: 'Donateur',
    // Whole-row click opens the detail sheet (the donor name is no longer a
    // standalone link); the full page stays reachable via its URL.
    cell: ({ row }) => (
      <span className="font-medium">{row.original.donor_name}</span>
    ),
  },
  {
    accessorKey: 'amount_formatted',
    header: 'Montant',
    meta: { sortKey: 'amount_millimes' },
    cell: ({ row }) => (
      <span className="tabular-nums">{row.original.amount_formatted}</span>
    ),
  },
  {
    accessorKey: 'donation_date',
    header: 'Date',
    meta: { sortKey: 'donation_date' },
    cell: ({ row }) =>
      new Date(row.original.donation_date).toLocaleDateString('fr-FR'),
  },
  {
    accessorKey: 'campaign_name',
    header: 'Campagne',
  },
  {
    accessorKey: 'payment_method_name',
    header: 'Mode de paiement',
  },
  {
    accessorKey: 'nature_name',
    header: 'Nature',
  },
  {
    accessorKey: 'status',
    header: 'Statut',
    meta: { sortKey: 'status' },
    cell: ({ row }) => {
      const label = typeof row.original.status === 'object' ? row.original.status.label : String(row.original.status)
      return (
        <Badge variant="outline">
          {label}
        </Badge>
      )
    },
  },
]
